import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ExtraCampaignsServiceProvider } from '../../api/extra-campaigns'

const ExtraCampaignsService = ExtraCampaignsServiceProvider()
const name = 'sendEmailsAlternativeCampaign'

/**
 * action - start/stop/continue/new
 * alternativeCampaignId
 **/

export default (action, alternativeCampaignId, employeeIds, emailTemplateId) => (asyncAction(
  name,
  ExtraCampaignsService.sendEmailsAlternativeCampaign,
  {
    action, alternativeCampaignId, employeeIds, emailTemplateId
  }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/extra-campaign/sendEmailsAlternativeCampaign.js